var favouriteTooltip = $('.btn-favourite__tooltip');
window.addRemoveFavourite = function(e) {
  
  e.preventDefault();
  e.stopImmediatePropagation();

  $this = $(this);
  var url;

  var request = null;

  if (request) {
    request.abort();
  }

  url = $this.hasClass("js-add-favourite-product") ? $this.data('add-favourite-url') : $this.data('remove-favourite-url');

  request = $.ajax({
    type: "GET",
    url: url,
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    beforeSend: function() {
      $this.addClass("btn--loading")
        .attr("disabled", true)
        .prop("disabled", true);
    },
    complete: function() {
      setTimeout(function() {

        $this.removeClass("btn--loading")
          .removeProp("disabled")
          .removeAttr("disabled");
        $this.data("loading", false);

      }, 500);

      request = null;
    },
    success: function(response) {

      var countLabel = $(".btn-favourites .btn-count-label");
      var count = parseInt(countLabel.html());
      if ($this.hasClass("js-add-favourite-product")) {

          favouriteTooltip.each(function(i,el) {
            if($this.data('id') == $(el).data('id')) {
              $(el).text('Премахни от любими');
            }
          });
          $this.removeClass("js-add-favourite-product");
          $this.addClass("js-remove-favourite-product");
          
          
          countLabel.html(count + 1);

      } else if ($this.hasClass("js-remove-favourite-product")) {
          
          $this.removeClass("js-remove-favourite-product");
          $this.addClass("js-add-favourite-product");

          countLabel.html(count - 1);

      }

    },
    error: function(err) {
      if (err.status == 401) {
        $('.header__login-btn').click();
      }
    }
  });

}

$(".link__product-card").on("click", ".js-add-favourite-product, .js-remove-favourite-product", addRemoveFavourite);

$(document).ready(function() {
	
	(function() {
    var favourite = $('.btn--favourite');
    favourite.each(function(i,el) {
      if($(el).hasClass('js-remove-favourite-product')) {
        favouriteTooltip.each(function(i,e) {
          if($(el).data('id') == $(e).data('id')) {
            $(e).text('Премахни от любими');
          }
        });
      }
    });
  })();
});